import * as React from "react";
import { Search } from "lucide-react";
import { cn } from "@/lib/cn";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-10 w-full rounded-xl border border-line bg-surface px-3.5 text-sm text-ink",
        "placeholder:text-ink-soft focus:outline-none focus:ring-2 focus:ring-brand/50 focus:border-brand transition",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const SearchInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <div className="relative flex-1 min-w-0">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft" />
      <input
        ref={ref}
        className={cn(
          "h-10 w-full rounded-xl border border-line bg-surface pl-9 pr-3.5 text-sm text-ink",
          "placeholder:text-ink-soft focus:outline-none focus:ring-2 focus:ring-brand/50 focus:border-brand transition",
          className,
        )}
        {...props}
      />
    </div>
  ),
);
SearchInput.displayName = "SearchInput";

export { Select } from "./Select";
